"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_FUNCTION = exports.TYPE_ERROR_ARRAY = exports.TYPE_ERROR_NORMAL = exports.TYPE_MODE_NORMAL = exports.TYPE_MODEL_ERROR_NO_SPECIAL_CHARACTER = exports.TYPE_MODEL_ERROR_NO_SPACE = exports.TYPE_MODEL_ERROR_MINIMUM = exports.TYPE_MODEL_ERROR_EMAIL = exports.TYPE_MODEL_ERROR_NUMBER = exports.TYPE_MODEL_ERROR_REQURIED = exports.TYPE_MODEL_ERROR_LIMIT = exports.TYPE_OBJECT = exports.TYPE_ARRAY = exports.TYPE_BUTTON = exports.TYPE_OTP = exports.TYPE_SUBMIT = exports.TYPE_PASSWORD = exports.TYPE_FILE = exports.TYPE_CUSTOMS = exports.TYPE_CHECK_BOX = exports.TYPE_NONE = exports.TYPE_CALCULATOR = exports.TYPE_SELECT = exports.TYPE_TIME = exports.TYPE_DATE = exports.TYPE_PHONE_NUMBER = exports.TYPE_RADIO = exports.TYPE_EMAIL = exports.TYPE_NUMBER = exports.TYPE_TEXT_AREA = exports.TYPE_TEXT = void 0;
exports.TYPE_TEXT = "text";
exports.TYPE_TEXT_AREA = "textarea";
exports.TYPE_NUMBER = "number";
exports.TYPE_EMAIL = "email";
exports.TYPE_RADIO = "radio";
exports.TYPE_PHONE_NUMBER = "phone_number";
exports.TYPE_DATE = "date";
exports.TYPE_TIME = "time";
exports.TYPE_SELECT = "select";
exports.TYPE_CALCULATOR = "calculate";
exports.TYPE_NONE = "none";
exports.TYPE_CHECK_BOX = "checkbox";
exports.TYPE_CUSTOMS = "customs";
exports.TYPE_FILE = "file";
exports.TYPE_PASSWORD = "password";
exports.TYPE_SUBMIT = "submit";
exports.TYPE_OTP = "otp";
exports.TYPE_BUTTON = "button";
exports.TYPE_ARRAY = "array";
exports.TYPE_OBJECT = "object";
exports.TYPE_MODEL_ERROR_LIMIT = "limit";
exports.TYPE_MODEL_ERROR_REQURIED = "required";
exports.TYPE_MODEL_ERROR_NUMBER = "number";
exports.TYPE_MODEL_ERROR_EMAIL = "email";
exports.TYPE_MODEL_ERROR_MINIMUM = "minimum";
exports.TYPE_MODEL_ERROR_NO_SPACE = "noSpace";
exports.TYPE_MODEL_ERROR_NO_SPECIAL_CHARACTER = "noSpecialCharacter";
exports.TYPE_MODE_NORMAL = "normal";
exports.TYPE_ERROR_NORMAL = "normal";
exports.TYPE_ERROR_ARRAY = "array";
exports.TYPE_FUNCTION = "function";
